export class NotFound extends Error {
    public constructor(error: string) {
        super(error);
    }
}
